import React from 'react';
import styled from 'styled-components';
import { Typography } from '../../../atoms/typography/Typography';
import { Stack } from '../../../atoms/stack/Stack';
import { Row } from '../../../atoms/row/Row';
import StarRating from '../../../molecules/shared/starRating/StarRating';

const BgIcon = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background-image: url('/icons/logo.svg');
  background-repeat: no-repeat;
  background-position: top -220px right -200px;
  background-size: 1000px;
`;

const Ratings = ({ sections }) => {
  const general = sections.find((el) => el.type === 'general');
  const rates = sections.find((el) => el.type === 'ratings');

  return (
    <div className="flex bg-white">
      <div className="flex w-full flex-col flex-1 lg:mx-auto max-w-7xl md:my-40 my-20">
        <div className="flex flex-col md:flex-row relative bg-primary-800 mx-8 rounded-[32px] px-5 py-8 sm:p-10 md:p-20 gap-10 lg:gap-20">
          <BgIcon />
          <Stack className="relative flex flex-1 md:flex-[0.5]">
            <Typography
              fontVariant="h8"
              textAlign="left"
              className="!text-secondary-400"
            >
              {general.label}
            </Typography>
            <Typography
              as="h2"
              fontVariant="h4"
              textAlign="left"
              className="!text-white"
            >
              {general.title}
            </Typography>
            <Stack className="gap-4">
              <Typography
                fontVariant="lg"
                textAlign="left"
                className="font-normal !text-white opacity-75"
              >
                {general.componentData.text1}
              </Typography>
              <Typography
                fontVariant="lg"
                textAlign="left"
                className="font-normal !text-white opacity-75"
              >
                {general.componentData.text2}
              </Typography>
            </Stack>
          </Stack>
          <Stack className="relative flex-1 md:flex-[0.5] justify-center gap-4">
            {rates.componentData.map((item) => (
              <Row
                key={item.text}
                className="justify-between gap-3 items-center"
              >
                <Typography
                  fontVariant="md"
                  textAlign="left"
                  className="w-fit font-medium !text-white"
                >
                  {item.text}
                </Typography>
                <StarRating rating={item.rating} />
              </Row>
            ))}
          </Stack>
        </div>
      </div>
    </div>
  );
};

export default Ratings;
